if (typeof document !== "undefined") {
  setTimeout(() => {
    // get's all video wrapper divs
    var youtube = document.querySelectorAll(".youtube");

    // iterates through all the divs
    for (var i = 0; i < youtube.length; i++) {
      var iframe = document.createElement("iframe");

      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute(
        "src",
        "https://www.youtube.com/embed/" +
          youtube[i].dataset.embed +
          "?rel=0&showinfo=0&autoplay=1"
      );
      iframe.style.display = "none";
      iframe.onload = () => {
        iframe.style.display = "block";
      };

      youtube[i].appendChild(iframe);
    }
  }, 1000);
}
